import React from 'react'
import { themr } from 'react-css-themr'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Logo from '../Logo'

export interface MobileMenuTheme {
  root?: string
  leftIcon?: string
  rightIcon?: string
}

const DumpMobileMenu = ({
  isShowDrawer,
  onToggleDrawer,
  theme = {},
}: {
  isShowDrawer: boolean
  onToggleDrawer: () => void
  theme?: MobileMenuTheme
}) => (
  <div className={theme.root}>
    <Logo className="white ttu ph2 ph3-m pv2 w3" />
    <a className={theme.leftIcon} onClick={onToggleDrawer}>
      {isShowDrawer ? (
        <FontAwesomeIcon icon="times" size="1x" />
      ) : (
        <FontAwesomeIcon icon="bars" size="1x" />
      )}
    </a>
  </div>
)

export const defaultMobileMenuTheme: MobileMenuTheme = {
  root:
    'flex items-center justify-between bg-white shadow-4 ph3 pv0 fixed top-0 w-100 z-3',
  leftIcon: 'pc pointer flex-none tl ba br-100 b--pc w2 h2 flex items-center justify-center',
  rightIcon: 'pc pointer flex-none tr ba br-100 b--pc w2 h2 flex items-center justify-center',
}

const MobileMenu = themr('MobileMenu', {}, { composeTheme: 'softly' })(
  DumpMobileMenu,
)

export default MobileMenu
